import * as actions from 'app/actions/user';
import http from 'app/services/http';

export const userReducer = (
    state = {
        items: [],
        typeItems: [],
        selectedItem: null,
        searchValue: '',
    },
    action
) => {
    switch (action.type) {
        case 'USER_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'USER_SET_SELECTED_ITEM': {
            const { data } = action.payload;
            if (!data) {
                return {
                    ...state,
                    selectedItem: null,
                };
            }
            const selectedItem = {
                ...data,
                transportGroups: [],
                transportGroupsId: [],
                checklistParkScope: data?.checklistParkScope ?? {
                    transport_group_ids: [],
                    transport_ids: [],
                },
            };
            if (selectedItem?.id === state?.selectedItem?.id) {
                selectedItem.transportGroups = state.selectedItem.transportGroups;
                selectedItem.transportGroupsId = state.selectedItem.transportGroupsId;
                selectedItem.checklistParkScope = state.selectedItem.checklistParkScope;
            }
            return {
                ...state,
                selectedItem,
            };
        }
        case 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    transportGroups: items,
                },
            };
        }
        case 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    transportGroups: state.selectedItem.transportGroups.map((item) => {
                        if (item.id !== id) {
                            return item;
                        }

                        return {
                            ...item,
                            checked: !item.checked,
                        };
                    }),
                },
            };
        }
        case 'USER_SET_SELECTED_ITEM_AUTOCOLONS_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    autocolons: items,
                },
            };
        }

        case 'USER_SET_SELECTED_ITEM_CHECKLIST_PARK_SCOPE': {
            const { transport_group_ids, transport_ids } = action.payload;

            return {
                ...state,
                selectedItem: {
                    ...state.selectedItem,
                    checklistParkScope: {
                        transport_group_ids: transport_group_ids ?? [],
                        transport_ids: transport_ids ?? [],
                    },
                },
            };
        }

        case 'USER_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'USER_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
                selectedItem: {
                    ...data,
                    transportGroups: [],
                    checklistParkScope: {
                        transport_group_ids: [],
                        transport_ids: [],
                    },
                },
            };
        }
        case 'USER_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }

                    return {
                        ...state.selectedItem,
                        ...data,
                    };
                }),
                selectedItem: {
                    ...state.selectedItem,
                    ...data,
                },
            };
        }
        case 'USER_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                items: state.items.filter((item) => item.id !== id),
                selectedItem: null,
            };
        }
        case 'USER_SET_TYPE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                typeItems: items,
            };
        }
        default:
            return state;
    }
};

export function userLoad() {
    return async function userLoadThunk(dispatch) {
        const { data } = await http.get('/user');
        return dispatch(actions.setItems(data));
    };
}

export function userCreate(params) {
    return async function userCreateThunk(dispatch) {
        const { data } = await http.post('/user', params);
        return dispatch(actions.addItem(data));
    };
}

export function userUpdate(id, params) {
    return async function userUpdateThunk(dispatch) {
        const { data } = await http.put(`/user/${id}`, params);
        return dispatch(actions.updateItem(data));
    };
}

export function userUpdatePassword(id, params) {
    return async function userUpdateThunk(dispatch) {
        const { data } = await http.post(`/user/${id}/password`, params);
        return dispatch(actions.updateItem(data));
    };
}

export function userDelete(id) {
    return async function userDeleteThunk(dispatch) {
        const { data } = await http.delete(`/user/${id}`);
        if (data) {
            dispatch(actions.deleteItem(id));
            return dispatch(actions.addItem(data));
        }
        return dispatch(actions.deleteItem(id));
    };
}

export function userUnblock(id) {
    return async function userDeleteThunk(dispatch) {
        dispatch(actions.deleteItem(id));
        const { data } = await http.put(`/user/${id}/unblock`);
        return dispatch(actions.addItem(data));
    };
}

export function userTypeFormLoad(withMyself = false) {
    return async function userTypeFormLoadThunk(dispatch) {
        const { data } = await http.get(`/user/role?mode=${withMyself ? 'create' : 'edit'}`);
        return dispatch(actions.setTypeItems(data));
    };
}

export function userTransportGroupLoad(id) {
    return async function userTransportGroupLoadThunk(dispatch) {
        const { data } = await http.get(`/user/${id}/group`);
        return dispatch(actions.setSelectedItemTransportGroupItems(data));
    };
}

export function userTransportGroupPush(id, value) {
    return async function userTransportGroupPushThunk(dispatch) {
        await http.post(`/user/${id}/group/${value}`);
        return dispatch(actions.setSelectedItemTransportGroupItem(value));
    };
}

export function userTransportGroupDelete(id, value) {
    return async function userTransportGroupPushThunk(dispatch) {
        await http.delete(`/user/${id}/group/${value}`);
        return dispatch(actions.setSelectedItemTransportGroupItem(value));
    };
}

export function userTransportGroupListPush(id, list) {
    return async function userTransportGroupPushThunk(dispatch) {
        await http.post(`/user/${id}/groups`, {
            list,
        });
        return list.map((value) => dispatch(actions.setSelectedItemTransportGroupItem(value)));
    };
}

export function userTransportGroupListDelete(id, list) {
    return async function userTransportGroupPushThunk(dispatch) {
        await http.delete(`/user/${id}/groups`);
        return list.map((value) => dispatch(actions.setSelectedItemTransportGroupItem(value)));
    };
}

export function userAutocolonPush(id, value) {
    return async function userAutocolonPushThunk(dispatch) {
        const { data } = await http.post(`/user/${id}/autocolon/${value}`);
        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function userAutocolonDelete(id, value) {
    return async function userAutocolonDeleteThunk(dispatch) {
        const { data } = await http.delete(`/user/${id}/autocolon/${value}`);
        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function userAutocolonsPush(id, list) {
    return async function userAutocolonsPushThunk(dispatch) {
        const { data } = await http.post(`/user/${id}/autocolons`, {
            list,
        });
        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function userAutocolonsListDelete(id, list) {
    return async function userAutocolonsListDeleteThunk(dispatch) {
        const { data } = await http.post(`/user/${id}/autocolons/delete`, {
            list,
        });
        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function userAutocolonsDelete(id) {
    return async function userAutocolonsDeleteThunk(dispatch) {
        const { data } = await http.delete(`/user/${id}/autocolons`);

        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function getUserAutocolons(id) {
    return async function getUserAutocolonsThunk(dispatch) {
        const { data } = await http.get(`/user/${id}/autocolons`);
        return dispatch(actions.setSelectedItemAutocolonsItems(data));
    };
}

export function putUserChecklistParkScope(id, body) {
    return async function putUserChecklistParkScopeThunk(dispatch) {
        const { data } = await http.put(`/user/${id}/checklist-park-scope`, body);
        return dispatch(
            actions.setSelectedItemChecklistParkScope({
                transport_group_ids: data.transport_group_ids,
                transport_ids: data.transport_ids,
            })
        );
    };
}

export default userReducer;
